// How much a Grow upgrade counts in ranked and the Halls (shared/pvp.ts): ascend, refine and awaken in full,
// stars at half strength (square root), stone training not at all.
export type PvpWeight = 'full' | 'half' | 'none';

const LABEL: Record<PvpWeight, [string, string]> = {
  full: ['PvP: full', 'Counts in full in ranked and the Halls'],
  half: ['PvP: half', 'Counts at about half strength in ranked and the Halls'],
  none: ['Hunts only', 'Not used in ranked or the Halls'],
};

export function pvpTag(w: PvpWeight): string {
  const [text, title] = LABEL[w];
  return `<span class="cp-pvp${w === 'none' ? ' off' : ''}" title="${title}">${text}</span>`;
}
